import React from 'react';

const statusColors = {
  pending: { bg: '#FFF8E1', text: '#E0A526' },
  picked_up: { bg: '#EDE7F6', text: '#3E2C6E' },
  in_transit: { bg: '#EDE7F6', text: '#3E2C6E' },
  delivered: { bg: '#EDE7F6', text: '#3E2C6E' },
  cancelled: { bg: '#ffebee', text: '#c62828' },
  failed: { bg: '#fce4ec', text: '#880e4f' },
  active: { bg: '#EDE7F6', text: '#3E2C6E' },
  busy: { bg: '#FFF8E1', text: '#E0A526' },
  offline: { bg: '#f5f5f5', text: '#999999' },
  admin: { bg: '#EDE7F6', text: '#3E2C6E' },
  staff: { bg: '#EDE7F6', text: '#3E2C6E' },
};

export default function Badge({ status, label, style, size = 'sm' }) {
  const colors = statusColors[status] || { bg: '#f5f5f5', text: '#666' };

  return (
    <span
      style={{
        display: 'inline-block',
        padding: size === 'sm' ? '3px 10px' : '6px 14px',
        borderRadius: '20px',
        backgroundColor: colors.bg,
        color: colors.text,
        fontSize: size === 'sm' ? 'var(--font-size-xs)' : 'var(--font-size-base)',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {label || status}
    </span>
  );
}
